import React, { Component } from 'react';
import ReactDOM from "react-dom";

/**
 * Component to load an existing order when a child req is searched.
 */
class LoadOrderFromSearch extends Component {
	
	/**
	 * Constructor binds component functions.
	 */
	constructor(props) {
		super(props);
		
		this.loadOrder = this.loadOrder.bind(this);
	}
	
	/**
	 * Show the modal when the component mounts.
	 */
	componentDidMount() {
		window.$(ReactDOM.findDOMNode(this)).modal("show");
		window.$(ReactDOM.findDOMNode(this)).on("hidden.bs.modal", this.props.modalHidden)
		// bootstrap puts a blur on ".modal-open .page-wrapper" and recommends placing modals in a top-level to prevent
		// other CSS from affecting the modal appearance. We can't do this though, because the react root is nested
		// pretty deep in the wrapping DOM, so instead we're programatically dropping the blurry styles
		window.$(".page-wrapper").css({
			"filter": "none",
			"-webkit-filter": "none",
			"-moz-filter": "none",
			"-o-filter": "none",
			"-ms-filter": "none"
		});
	}
	
	/**
	 * Loads the order.
	 */
	loadOrder() {
		this.props.loadOrder( this.props.orderToLoad, this.props.reqToLoad.id );
	}
	
	/**
	 * Renders the load order modal component.
	 */
	render() {
		let medicareSwitchWarning;
		const { isMedicareSelected, isOrderMedicare, isOrderableItemMedicareEligible, orderableItemName } = { ...this.props.displayLoadOrderMedicareDetails };
		if (isMedicareSelected && !isOrderMedicare) {
			if (!isOrderableItemMedicareEligible) {
				medicareSwitchWarning = (
					<span>
						Medicare or Tricare billing is not available for the {orderableItemName || ''} test. If you
						choose to load order #{this.props.orderToLoad.id}, you will be switched to a non-Medicare order.
					</span>
				);
			}
		}

		return (
			<div className="modal fade" id="loadOrderFromSearchModal" tabIndex="-1" role="dialog">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-header">
							<button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
							<h4 className="modal-title">Load Order</h4>
						</div>
						<div className="modal-body">
						
						<p>Requisition {this.props.reqToLoad.reqNumber} is part of order #{this.props.orderToLoad.id}.<br />
							Would you like to load order #{this.props.orderToLoad.id}?
						</p>
						<div className="panel panel-info">
							<div className="panel-heading">
								<h3 className="panel-title">Order #{this.props.orderToLoad.id}</h3>
							</div>
							<div className="panel-body">
								<table className="table">
									<tbody>
										{this.props.orderToLoad.requisitions.map( req => 
											<tr key={req.id}>
												<td>{req.reqNumber}</td>
												<td>{req.omsOrderableItemName}</td>
											</tr>
										)}
									</tbody>
								</table>
							</div>
						</div>
						
						{medicareSwitchWarning && (
							<div className="alert alert-info mt-0 mb-0">{medicareSwitchWarning}</div>
						)}
						
						</div>
						<div className="modal-footer">
							<button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={this.loadOrder}>Yes</button>
							<button type="button" className="btn btn-light" data-bs-dismiss="modal">No</button>
						</div>
					</div>
				</div>
			</div>
		);
	};
}

export default LoadOrderFromSearch;
